import React, { useState, type FC, useEffect, type ReactNode } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Form, type TableProps } from 'antd';
import { Modal, Space } from '@g2u/ui-kit';

import { Technician, type Customer, type WithOptionalDataTest } from 'types';
import { SearchTechnician } from 'components';

export namespace TechnicianSearchModal {
  export type Props = TableProps<Technician> & {
    isOpen: boolean;
    onOk: () => void;
    onCancel: () => void;
    actions?: SearchTechnician.Props['actions'];
    customer?: Customer | null;
    modalTitle: ReactNode | string;
    emptyContent?: SearchTechnician.Props['emptyContent'];
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { onCancel, isOpen, actions, emptyContent, modalTitle, dataTestId } = props;
    const [showModal, setShowModal] = useState<boolean>(isOpen);
    const [form] = Form.useForm();
    Form.useWatch([], { form });

    useEffect(() => {
      setShowModal(isOpen);
    }, [isOpen]);

    return (
      <Modal.$
        wide
        footer={null} // TODO: enable buttons when complex flow is required
        open={showModal}
        destroyOnClose
        maskClosable={false}
        title={modalTitle}
        onOk={() => form.submit()}
        onCancel={onCancel}
        closeIcon={<CloseOutlined />}
        dataTestId={dataTestId ?? 'technician-search-modal'}
      >
        <SearchTechnician.$
          actions={actions}
          emptyContent={
            emptyContent
              ? (formValues) => (
                  <Space.$ align={Space.Align.Center} direction={Space.Direction.Vertical}>
                    {emptyContent(formValues)}
                  </Space.$>
                )
              : undefined
          }
        />
      </Modal.$>
    );
  };
}
